import React from 'react';
import { motion } from 'framer-motion';

// Mascot images (transparent-background WebP; the source PNGs have opaque
// white backgrounds that box the mascot on dark surfaces)
const DRAFTY_IMAGES = {
  default: '/images/Drafty-grading.webp',
  thinking: '/images/Drafty-contemplating.webp',
  excited: '/images/Drafty-celebrating.webp'
};

export const DraftyMascot = ({ size = 'md', mood = 'default', className = '' }) => {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-20 h-20',
    lg: 'w-32 h-32',
    xl: 'w-48 h-48'
  };

  return (
    <motion.div
      className={`${sizeClasses[size]} ${className}`}
      animate={{ y: [0, -8, 0] }}
      transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
    >
      <img
        src={DRAFTY_IMAGES[mood] || DRAFTY_IMAGES.default}
        alt="Drafty the AI Writing Coach"
        className="w-full h-full object-contain drop-shadow-lg"
      />
    </motion.div>
  );
};

export default DraftyMascot;
